import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SearchResults from "../SearchAgent/SearchResults/searchresults";
import SearchBarSelector from "../SearchBars/searchbarselector";
import SearchOptions from "./SearchOptions/SearchOptions";
import "./priceoffercomponent.css";
import PassangerData from "./subComponents/PassangerData/passangerdata";
import OrderSummery from "../OrderSummery/ordersummery";
import { useOrder } from "../../../contexts/OrderContext";
import { Loader } from "../../Loader/Loader";
import {
  getHotelsProfileData,
  searchFlights,
} from "../../../services/fhpService";
import { useAppContext } from "../../../contexts/AppContext";
import { DYNAMIC_PACKAGES, useSearch } from "../../../contexts/SearchContext";
import { notification } from "antd";
import { useSelectedResult } from "../../../contexts/SelectedResultContext";
import { getDynamicOrder } from "../../../services/dynamicService";

const PriceOfferComponent = ({ changeClient, clientsInfoParam }) => {
  const navigate = useNavigate();
  const loggedUser = JSON.parse(localStorage.getItem("UserInfo"));
  const { selectedObject, dynamicOrderId } = useParams(); // Checks if picked a room / flight ...
  const { isMobile, calcBaseCommission, isGlobalConstantLoaded } =
    useAppContext();
  const {
    dynamicOrder,
    setDynamicOrder,
    setLdsSupplement,
    setRoomsAndPaxInfo,
    handleFeeData: ldsHandleFeeData,
    updateHandleFeeData,
  } = useSelectedResult();
  const isLoadingRef = useRef(false);
  const [hasInitialized, setHasInitialized] = useState(false);
  const isInitializingRef = useRef(false);
  const currentDynamicOrderIdRef = useRef(dynamicOrderId);
  const {
    setHandleFeeData,
    handleFeeData,
    currentHotelOrder,
    setCurrentHotelOrder,
  } = useOrder();
  const [searchPhrase, setSearchPhrase] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const { searchTab, setSearchTab, availableFlights, setAvailableFlights } =
    useSearch();
  const { t } = useTranslation();
  const [clientsInfo, setClientsInfo] = useState(
    clientsInfoParam || {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      countryCode: "",
      passportNumber: "",
      passportExpiryDate: "",
      passportCountry: "",
      passportType: "",
      dateOfBirth: "",
    }
  );

  const dynamicHandleFeeData = useMemo(() => {
    return {
      type: ldsHandleFeeData?.type || "+",
      value:
        ldsHandleFeeData?.type == "%"
          ? ldsHandleFeeData?.value || 0
          : (ldsHandleFeeData?.value || 0) + (handleFeeData?.value || 0),
    };
  }, [ldsHandleFeeData, handleFeeData]);

  const setDynamicHandleFeeData = (type, value) => {
    if (type === "+") value = value / 2;
    setHandleFeeData(type, value);
    updateHandleFeeData(type, value);
  };

  const getHotelInfo = async (searchPhrase) => {
    // Get hotel information

    const res = await getHotelsProfileData(searchPhrase);

    // Transfer to hotel profile
    if (res?.status === 200) {
      return res.data;
    } else {
      return null;
    }
  };

  const updateDynamicOrder = () => {
    console.log("updateDynamicOrder called:", {
      isGlobalConstantLoaded,
      dynamicOrderId,
      isLoading: isLoadingRef.current,
      hasInitialized,
      isInitializing: isInitializingRef.current,
      currentOrderId: currentDynamicOrderIdRef.current,
    });

    // Prevent multiple calls - exit if already loading, already initialized, or currently initializing
    if (
      !isGlobalConstantLoaded ||
      !dynamicOrderId ||
      isLoadingRef.current ||
      hasInitialized ||
      isInitializingRef.current
    ) {
      console.log("updateDynamicOrder early return");
      return;
    }

    // Check if this is for a different dynamicOrderId
    if (currentDynamicOrderIdRef.current !== dynamicOrderId) {
      console.log("dynamicOrderId changed, resetting state");
      setHasInitialized(false);
      setErrorMessage(null);
      currentDynamicOrderIdRef.current = dynamicOrderId;
    }

    // Set the initializing flag
    isInitializingRef.current = true;
    console.log("Starting dynamic order fetch");
    if (searchTab !== DYNAMIC_PACKAGES) {
      setSearchTab(DYNAMIC_PACKAGES);
    }
    let data = localStorage.getItem("UserInfo");
    const agentId = data ? JSON.parse(data).id : 0;

    isLoadingRef.current = true;

    getDynamicOrder({
      id: dynamicOrderId,
      agentID: agentId,
    })
      .then((res) => {
        if (res.status === 200) {
          setDynamicOrder(res.data);
          setClientsInfo(res.data.clientsinfo);
          const hotel = res.data.hotel;
          const flights = res.data.flights;
          const hotelInfo = res.data.offer;
          if (hotel && hotelInfo) {
            setDynamicHandleFeeData(
              hotel.handle_fee_option,
              hotel.handle_fee_option === "%"
                ? hotel.handlingfee
                : hotel.handlingfee * 2
            );
          } else {
            throw new Error("Hotel or hotelInfo is null");
          }
          if (flights) {
            if (flights?.passengersinfo)
              setRoomsAndPaxInfo(flights?.passengersinfo || {}, false);
            const fp = flights.ourprice.ourTotalFare.ldsPrice;
            const lf = { ...flights.linkedflights, ldsPrice: fp };
            const supplements = flights.supplement;
            if (lf) {
              const calendarDateArrival = res.data.check_in;
              const calendarDateLeave = res.data.check_out;
              const originString = lf.flight[0].leg.depCity;
              const destinationString = lf.flight[0].leg.arrCity;
              const sp = {
                ...hotelInfo.searchPhrase,
                // session: undefined
              };
              if (sp) {
                getHotelInfo(sp).then((res) => {
                  if (res.error) {
                    notification.error({
                      message: t("errorMessages.hotelInfoError"),
                      description: t("errorMessages.hotelIsNotAvailable"),
                      duration: 0,
                      placement: "bottomRight",
                    });
                    setSearchPhrase(sp);
                    setCurrentHotelOrder(hotelInfo);
                  } else {
                    setSearchPhrase({
                      ...sp,
                      session: res.session,
                    });
                    const selectedRoomSet = res.boxes.find((box) =>
                      box.roomNames.every((roomName) =>
                        hotelInfo.selectedRoom.roomNames.includes(roomName)
                      )
                    );

                    if (!selectedRoomSet) {
                      setCurrentHotelOrder(hotelInfo);
                      return;
                    }

                    const checkInOutInfo = {
                      checkIn: hotelInfo.searchPhrase.checkIn,
                      checkOut: hotelInfo.searchPhrase.checkOut,
                    };

                    const previousHotelPackage = hotelInfo.selectedHotelPackage;

                    let newHotelPackage = selectedRoomSet.packages.filter(
                      (pkg) =>
                        pkg.roomBasis === previousHotelPackage.roomBasis &&
                        pkg.refundability ===
                          previousHotelPackage.refundability &&
                        pkg.refundableUntil ===
                          previousHotelPackage.refundableUntil
                    );

                    if (newHotelPackage.length === 1) {
                      newHotelPackage = newHotelPackage[0];
                    } else {
                      // find the package with the lowest finalPrice
                      newHotelPackage = newHotelPackage.reduce(
                        (minPkg, pkg) =>
                          pkg.finalPrice < minPkg.finalPrice ? pkg : minPkg,
                        newHotelPackage[0]
                      );
                    }

                    if (!newHotelPackage) {
                      const hotelID = sp.hotelID;
                      navigate(
                        "/hotelprofile/" +
                          hotelID +
                          (dynamicOrderId ? "/dynamic/" + dynamicOrderId : "")
                      );
                      notification.info({
                        message: t("errorMessages.hotelPackageError"),
                        description: t(
                          "errorMessages.hotelPackageIsNotAvailable"
                        ),
                      });
                      return;
                    }

                    newHotelPackage = {
                      ...newHotelPackage,
                      roomNames: selectedRoomSet.roomNames,
                      ourPrice: {
                        ...hotelInfo.ourPrice,
                        ...calcBaseCommission(newHotelPackage.finalPrice),
                      },
                    };

                    const packageRoomHotelData = {
                      searchPhrase: {
                        ...sp,
                        session: res.session,
                      },
                      selectedHotel: res,
                      selectedHotelPackage: newHotelPackage,
                      checkInOutInfo: checkInOutInfo,
                      selectedRoom: selectedRoomSet,
                      ourPrice: newHotelPackage.ourPrice,
                    };
                    setCurrentHotelOrder(packageRoomHotelData);
                  }
                });
              } else {
                isLoadingRef.current = false;
                setHasInitialized(true);
                setErrorMessage(t("errorMessages.dynamicOrderNotFound"));
                isInitializingRef.current = false; // Clear the initializing flag
                return;
              }
              const rooms = sp.rooms.map((room) => ({
                adults: room.AdultsCount,
                infants: room.InfantsCount,
                kids: room.KidsAges.length,
                kidsAges: room.KidsAges,
              }));
              searchFlights({
                dep_date: calendarDateArrival,
                ret_date: calendarDateLeave,
                origin: originString,
                destination: destinationString,
                room_compositions: rooms,
              })
                .then((res) => {
                  if (res?.data?.deal)
                    setAvailableFlights(res.data.deal, lf, supplements);
                  else {
                    setErrorMessage(t("errorMessages.searchFlightsError"));
                  }
                  isLoadingRef.current = false;
                  setHasInitialized(true); // Mark as initialized after successful completion
                  isInitializingRef.current = false; // Clear the initializing flag
                })
                .catch((err) => {
                  console.log(err);
                  setErrorMessage(t("errorMessages.searchFlightsError"));
                  isLoadingRef.current = false;
                  setHasInitialized(true); // Mark as initialized even on error to prevent retries
                  isInitializingRef.current = false; // Clear the initializing flag
                });
            } else {
              isLoadingRef.current = false;
              setErrorMessage(t("errorMessages.dynamicOrderNotFound"));
              isInitializingRef.current = false; // Clear the initializing flag
            }
            if (supplements) {
              setLdsSupplement(supplements);
            }
          }
          isLoadingRef.current = false;
          setHasInitialized(true);
          isInitializingRef.current = false; // Clear the initializing flag
        } else {
          isLoadingRef.current = false;
          setHasInitialized(true);
          setErrorMessage(t("errorMessages.dynamicOrderNotFound"));
          isInitializingRef.current = false; // Clear the initializing flag
        }
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage(t("errorMessages.dynamicOrderError"));
        isLoadingRef.current = false;
        setHasInitialized(true); // Mark as initialized even on error to prevent retries
        isInitializingRef.current = false; // Clear the initializing flag
      });
  };
  useEffect(() => {
    console.log("useEffect triggered:", {
      isGlobalConstantLoaded,
      dynamicOrderId,
    });
    if (!isGlobalConstantLoaded) return;
    updateDynamicOrder();
  }, [isGlobalConstantLoaded, dynamicOrderId]); // Only depend on these two values

  // No need for a separate reset effect since we handle it inside updateDynamicOrder

  if (errorMessage)
    return (
      <div
        className="error"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div
          className="error-message"
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            color: "red",
            textAlign: "center",
          }}
        >
          שגיאה: {errorMessage}
        </div>
      </div>
    );
  if (isLoadingRef.current)
    return (
      <div className="price-offer-loader-wrapper">
        <Loader />
      </div>
    );

  if (dynamicOrderId) {
    if (!currentHotelOrder || !dynamicOrder || !availableFlights)
      return (
        <div className="price-offer-loader-wrapper">
          <Loader />
        </div>
      );
    else
      return (
        <>
          <div className="tw-p-[5%]">
            <div
              className={
                "price-offer-content-wrapper tw-flex lg:tw-flex-row tw-flex-nowrap tw-w-full tw-h-full" +
                (loggedUser ? " tw-flex-col-reverse" : " tw-flex-col")
              }
            >
              {currentHotelOrder ? (
                <PassangerData
                  dynamicOrder={dynamicOrder}
                  clientsInfo={clientsInfo}
                />
              ) : (
                <div className="price-offer-passenger-error">
                  Somthing Went Wrong
                </div>
              )}

              <div
                className={`price-offer-data-wrappers price-offer-order-details-wrapper lg:tw-w-[45%]`}
              >
                <OrderSummery
                  clientsInfo={clientsInfo}
                  savedSearchPhrase={searchPhrase}
                />
              </div>
            </div>
          </div>
        </>
      );
  }

  // Thats means that the user selected a room
  if (selectedObject) {
    return (
      <>
        <div className="tw-p-[5%]">
          {/* Search Results */}
          <div>
            {/* Search Bar */}
            {/*Search Results / Order Summery*/}
            {/* <div>
              <Timer />
            </div> */}
            <div
              className={
                "price-offer-content-wrapper tw-flex lg:tw-flex-row tw-flex-nowrap tw-w-full tw-h-full tw-flex-col-reverse"
              }
            >
              {currentHotelOrder ? (
                <PassangerData clientsInfo={clientsInfo} />
              ) : (
                <div className="price-offer-passenger-error">
                  Somthing Went Wrong
                </div>
              )}

              <div
                className={`price-offer-data-wrappers price-offer-order-details-wrapper lg:tw-w-[45%]`}
              >
                <OrderSummery
                  savedSearchPhrase={searchPhrase}
                  clientsInfo={clientsInfo}
                ></OrderSummery>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="tw-py-[70px] lg:tw-pr-[5%]">
        {/* Search Results */}
        <div
          className="price-offer-content-wrapper tw-flex lg:tw-flex-row tw-flex-nowrap tw-w-full tw-h-full"
          style={{ flexDirection: "column" }}
        >
          <div className="searchAgent-search-bar-option-wrapper">
            <div className="price-offer-change-user-search-option-wrapper">
              {/* Search Options / Flight ways */}
              {isMobile && (
                <div className="price-offer-search-option-wrapper-wrapper">
                  <SearchOptions />
                </div>
              )}
            </div>

            {/* Search Bar Selector */}
            <div className="searchAgent-search-bar-wrapper">
              <SearchBarSelector />
            </div>
          </div>
          <SearchResults />
        </div>
      </div>
    </>
  );
};

export default PriceOfferComponent;
